// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactHubModal-cls1_poY","cls2":"ImpactHubModal-cls2_9sk ImpactHubModal-cls1_poY"};